import { Component } from '@angular/core';

@Component({
    selector: 'app-blog-watermark-pdf',
    imports: [],
    templateUrl: './blog-watermark-pdf.component.html',
    styleUrl: './blog-watermark-pdf.component.css'
})
export class BlogWatermarkPdfComponent {

}
